// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"316":"74953c95","353":"4eeae25d"}[chunkId] + ".chunk.css";
};